import { IS_ADMIN } from "globalconfig/constants/validation";

export default {
  "Select All": "Select All",
  "This field is required": "This field is required",
  "Add New Company": "Add New Company",
  "COMPANY REGISTRATION": "COMPANY REGISTRATION",
  "COMPANY INFORMATION": "COMPANY INFORMATION",
  "SUBSCRIPTION LIST": "SUBSCRIPTION LIST",
  "Account": "Account",
  "Switch to Old View": "Switch to Old View",
  "Messaging": "Messaging",
  "Logout": "Logout",
  "MANAGE LOGS": "MANAGE LOGS",
  "Date": "Date",
  "Total Hours Worked": "Total Hours Worked",
  "Total Distance": "Total Distance",
  "Driver Name": "Driver Name",
  "Vehicle Name": "Vehicle Name",
  "Upload": "Upload",
  "No file selected": "No file selected",
  "Cancel": "Cancel",
  "Save": "Save",
  "Reset": "Reset",
  "The email is not valid": "The email is not valid",
  "LOG BOOK": "LOG BOOK",
  "Description": "Description",
  "Date (in UTC)": "Date (in UTC)",
  "VIEW DOCUMENT": "VIEW DOCUMENT",
  "NEXT": "NEXT",
  "PREV": "PREV",
  "DAILY LOG HISTORY": "DAILY LOG HISTORY",
  "Actions": "Actions",
  "Annotation": "Annotation",
  "Modified By": "Modified By",
  "Version": "Version",
  "ELD": "ELD",
  "OTHER": "OTHER",
  "LOG IN": "LOG IN",
  "REGISTRATION": "REGISTRATION",
  "Forgot": "Forgot your password?",
  "ForgotHeading": "We’ll help you reset it and get back on track.",
  "viewSample": "View Sample",
  "Forgot password?": "Forgot password?",
  "Remember me": "Remember me",
  "backLogin": "Back to Login",
  "emailAddress": "Email address",
  "Log in": "Log in",
  "If your email address is registered with us, you will receive a password recovery link at your email address": {},
  "FDCSA info": "NB: This will send files to FMCSA via email or Web Services as outlined in Appendix A to Subpart B of Part 395",
  'mail@gmail.com': 'mail@gmail.com',
  "Password": "Password",
  "email": "email",
  "Email": "Email",
  "EDIT DAILY LOG": "EDIT DAILY LOG",
  "Email or Employee Id": "Email or Employee Id",
  "Send a Message": "Send a Message",
  'Select Drivers here': 'Select Drivers here',
  'Select Drivers here...': 'Select Drivers here...',
  "Type": "Type",
  "Logs": "Logs",
  "Export": "Export",
  "Start Time": "Start Time",
  "End Time": "End Time",
  "Assigned Driver": "Assigned Driver",
  "Co-Driver": "Co-Driver",
  "Status": "Status",
  "PREVIOUS": "PREVIOUS",
  "Last Name": "Last Name",
  "apology": "Our apologies",
  "page moved": "That page was moved or deleted.",
  "send feedback": "Please send us feedback",
  "here": "here",
  "First Name": "First Name",
  "Registration Date": "Registration Date",
  "Un authorized": "Un authorized",
  "USER INFORMATION": "USER INFORMATION",
  "selectWithDot": "Select...",
  "Cost Per Truck $": "Cost Per Truck $",
  "Activate": "Activate",
  "Requested By": "Requested By",
  "Date Requested": "Date Requested",
  "Prepaid Expiration Date": "Prepaid Expiration Date",
  "Monthly Minimum $": "Monthly Minimum $",
  "Zoho Customer Id": "Zoho Customer Id",
  "Additional Line Items": "Additional Line Items",
  "Enable additional line items": "Enable additional line items",
  "Prepaid Amount": "Prepaid Amount",
  "Seperate DVIR only": "Seperate DVIR only",
  "By Vehicle": "By Vehicle",
  "By Driver": "By Driver",
  "WL Billing Info": "WL Billing Info",
  "commissionRate": "Commission Rate",
  "goToInspections": "to go back to Inspections",
  "forgotPassword": "Forgot password ?",
  "logo": "Logo",
  "parentProducer": "Parent Reseller",
  "policyHolder": "Policy Holder",
  "resellerInformation": "Reseller Information",
  "resellerName": "Reseller Name",
  "resetPassword": "Reset Password",
  "suspendCompany": "Suspend Company",
  "theme": "Theme",
  "footer": {
    "address": {
      "one": "Corporate Office",
      "two": "Office",
      "three": "Online",
      "onedetails": "Houston, TX",
      "twodetails": "844-636-1360",
      "threedetails": "info@gorillasafety.com"
    },
    "patent": "Patent pending",
    "copyright": "Copyright 2020",
    "PrivacyLegal": "Privacy & Legal"
  },
  "serviceRequest": {
    "pendingMechanic": "Pending Mechanic",
    "pendingDriver": "Pending Driver",
    "completed": "Completed",
    "manageServiceRequest": "Manage Service Requests"
  },
  "alerts": {
    "activated": "Activated Successfully!",
    "deactivated": "Deactivated Successfully!"
  },
  "errorTexts": {
    "max120Char": "Please enter a maximum of 120 characters.",
    "max50Char": "Please enter a maximum of 50 characters."
  },
  "camera": {
    "listHeading": "Camera",
    "camera_serial_no": "S. No.",
    "cameraStatus": "Status",
    "vehicles": "Vehicle",
    "simState": "Sim Status",
    "dateTimeFrom": "Date/Time From",
    "dateTimeTo": "Date/Time To",
    "lastConnectTime": "Last Connect Time",
    "lastDisconnectTime": "Last Disconnect Time",
    "vehicle": "Vehicle",
    "event_type": "Event Type",
    "camera_view": "View",
    "event_level": "Level",
    "date": "Date",
    "time": "Time",
    "cycle": "Cycle",
    "startDate": "Start Date",
    "endDate": "End Date",
    "Fleet": "Fleets",
    "tabs": {
      "dataUsage": "Data Usage",
      "events": "Events"
    }
  },
  "cameraEvents": {
    "listHeading": "Camera Events",
    "event_count": "Event Count",
    "event_type": "Event Type",
    "last_occurrence": "Last Occurrence Date",
    "vehciles": "Vehicles",
    "totalcounts": "Total Event Count",
    "eventsTypes": "Event Types"
  },
  "manageProfile": {
    "editProfile": {
      "heading": "EDIT PROFILE"
    }
  },
  "common": {
    deactivate: 'Deactivate',
    "Cell Phone": "Cell Phone",
    "Confirm Password": "Confirm Password",
    "resetPassword": "Reset password",
    "companyInfo": "Company Information",
    "noDataAvailable": "No data available",
    "noOfTruck": "Number of Truck",
    "subscriptionTier": "Subscription Tier",
    "payButtonText": "Update Card Now",
    "expiredContract": "Your account has been restricted. Please update the card or contact your service provider to activate.",
    "expiredContractPay": "Your account has been restricted. Please pay pending bill or contact your service provider to activate.",
    "payButtonTextPay": "Pay Now",
    "saveCCButtonTextPay": "Pay Now",
    "saveCCButtonText": "Update Credit Card",
    "cardHolder": "Card Holder",
    "updateCardDetails": "Update Credit Card",
    "adminProperty": "ADMIN'S PROPERTIES",
    "costperTruck": "Cost per Truck (Global) $",
    "costPerTruckPrime": "Cost per Truck (Prime8 ELD) $",
    "costPerTruckXtreme": "Cost per Truck (Xtreme) $",
    "costperTruckFleet": "Cost per Truck (Fleet Xpress) $",
    "startDate": "Start Date",
    "acceptPopup": "Yes, accept it!",
    "account": "Account",
    "accountNumber": " Account Name",
    "actions": "Actions",
    "activateMessage": "You will activate this user!",
    "activateMessageAdmin": "You will activate this Admin User!",
    "activateMessageReseller": "You will activate this Reseller!",
    "add": "Add",
    "address": "Address",
    "admin": "Admin",
    "alerts": "Alerts",
    "updateCard": "Update Credit Card",
    "paymentInfo": "Billing Information",
    "alertSp": "Compliance Notifications",
    "all": "All",
    "annotation": "Annotation",
    "assignedDriver": "Assigned Driver",
    "assignedVehicle": "Assigned Vehicle",
    "atleast2Chars": "Please enter at least 2 characters.",
    "atleast4chars": "Please enter at least 4 characters.",
    "authenticate": "Authenticate",
    "authenticateMFA": "Authenticate",
    "back": "back",
    "backToList": "Back To List",
    "breadcrumb": "Applied Filters :",
    "bulkDownloadReport": "Bulk Download Reports",
    "businessAddress": "Business Address",
    "camera": "Camera",
    "cameraPassword": "Camera Password",
    "cameraSerialNo": "Camera Serial No",
    "cameraStatus": "Camera Status",
    "cameraUrlNotFound": "Your account is not registered in Camera portal. Please register in camera portal and try again.",
    "cancel": "Cancel",
    "viewCompanies": "View Companies",
    "cardDetails": "Card Details Updated Successfully",
    "carrierName": "Carrier",
    "cellPhone": "Cell Phone",
    "choosePortal": "Choose Portal",
    "city": "City",
    "claimAdjuster": "Claim Adjuster",
    "clear": "Clear",
    "clearAll": "Clear All",
    "coDriver": "Co-Driver",
    "coDriverId": "coDriverId",
    "company": "Company",
    "dot": "DOT #",
    "activeTrucks": "Active Trucks",
    "payment": "BILLING DETAILS",
    "contractLength": "Contract Length",
    "contractExpiration": "Contract Expiration",
    "registrationDate": "Registration Date",
    "companyType": "Company Type",
    "confirm": "Confirm",
    "confirmPassword": "Confirm Password",
    "confirmPasswordMessage": "Please enter the same value again.",
    "createAdmin": "Admin Successfully created",
    "createResellerUser": "Reseller User Successfully created",
    "currentOdometer": "Current Odometer",
    "customerName": "Customer Name",
    "customPolicyTemplate": "Click  to view custom policy template",
    "cycleRule": "Cycle Rule",
    "dataImportSuccess": "Data has been imported successfully",
    "date": "Date",
    "dateFrom": "Date From",
    "datePicker": "mm/dd/yyyy",
    "dateTo": "Date To",
    "delete": "Delete",
    "deleteAdminResellerInfo": "This action cannot be undone.",
    "deleteDepartment": "Department deleted successfully",
    "deletePopup": "Yes, delete it!",
    "deleteRegion": "Region deleted successfully",
    "deleteTerminal": "Terminal deleted successfully",
    "deleteUserAdminReseller": "Are you sure want to delete Reseller User?",
    "deleteVehicles": "Are you sure want to delete this vehicle?",
    "deleteTrailer": "Are you sure want to delete this trailer?",
    "department": "Department",
    "departmentAdded": "Department added successfully",
    "departments": "Departments",
    "departmentUpdated": "Department updated successfully",
    "description": "Description",
    "deviceSn": "Device SN",
    "deviceType": "Device Type",
    "disableMFA": "Disable MFA",
    "disablePopup": "Yes, Disable",
    "discount": "Discount %",
    "distance": "Distance",
    "document": "Document",
    "documents": "Documents",
    "dotNumber": "DOT No.",
    "dotOfficerCode": "Dot Officer Code",
    "driver": "Driver",
    "driverId": "driverId",
    "driverName": "Driver Name",
    "driverNamejobName": "Job Name",
    "driverPhone": "Driver Phone",
    "drivers": "Driver",
    "drivingState": "Driving state",
    "edit": "Edit",
    "email": "Email",
    "emailValidationMessage": "Please enter valid email format",
    "employeeId": "Employee Id",
    "en": "English",
    "enableMFA": "Enable MFA",
    "enablePopup": "Yes, Enable",
    "endTime": "End Time",
    "es": "Spanish",
    "export": "Export",
    "exportAll": "Export All",
    "exportData": "Export Data",
    "failed": "Failed to Update",
    "fieldRequiredMessage": "This field is required.",
    "filterRequiredMessage": "Please select atleast one filter",
    "finish": "Finish",
    "firstname": "First Name",
    "firstName": "First Name",
    "fleetManager": "Fleet Manager",
    "fleetManagerDefault": "Fleet Manager (Default)",
    "fleetopsUrlNotFound": "This feature is not configured for your account.",
    "fromLocation": "From",
    "fullName": "Full Name",
    "fullname": "Fullname",
    "geocodedLocation": "Geocoded Location",
    "gvw": "GVW",
    "hardwareDevice": "Hardware Device",
    "hideNotification": "Hide Notification",
    "hireDate": "Hire Date",
    "history": "History",
    "hours": "Hours",
    "hoursDriving": "Hours Driving",
    "hoursWorked": "Hours Worked",
    "import": "Import",
    "importUser": "Import User",
    "isValidVin": "VIN number must be 17-character long. Numbers and letters only. I, O, or Q are not allowed",
    "language": "Language",
    "lastname": "Last Name",
    "lastName": "Last Name",
    "licenceNumber": "License Number",
    "liveCamera": "Live-Streaming",
    "location": "Location",
    "locationAdded": "Location added successfully",
    "locationDeleted": "Location deleted successfully",
    "locationOfLogSigning": "Location Of Log Signing",
    "locationUpdated": "Location updated successfully",
    "logbookDetails": "Daily Log for",
    "logHistory": "DAILY LOG HISTORY",
    "lossControl": "Loss Control",
    "mainAddress": "Main Address",
    "mainInformation": "Main Information",
    "make": "Make",
    "manageAdmin": "Manage Admin",
    "manageDailyDocuments": "MANAGE DAILY DOCUMENTS",
    "manageSubscription": "Manage Subscription",
    "max30Chars": "Maximum allowed 50 characters.",
    "maxChar": "maximum 50 character",
    "maxValueMessage": "maximum 100%",
    "mechanic": "Mechanic",
    "message": "Message",
    "mfacode": "MFA code",
    "minChar": "minimum one char required",
    "minimumRow": "Minimum 1 row is required",
    "minValueMessage": "minimum 0%",
    "modifiedBy": "Modified By",
    "mph": "MPH",
    "name": "Name",
    "next": "Next",
    "nextMaintenanceDate": "Next Maintenance Date",
    "nextMaintenanceMileage": "Next Maintenance Mileage",
    "no": "No",
    "noBreadcrumbData": "No Data Found to plot the BreadCrumb",
    "noData": "Nothing to display",
    "noDataToPlot": "No Data to plot",
    "noDuplicateEmail": "No duplicate accident emails are allowed",
    "noMoreThan9": "Please enter no more than 9 characters.",
    "note": "note",
    "notes": "Notes",
    "notificationList": "Notification List",
    "ok": "OK",
    "otherContact": "Other Contact",
    "pageNotFound": "Page not found",
    "partAdded": "Parts added successfully",
    "password": "Password",
    "passwordIsNotMatching": "The confirm password is not match with password",
    "passwordValidMessage": "Password must have at least an uppercase character, a lowercase character, a digit, a special character, at least 6 characters and at most 15 characters long.",
    "paymentName": "Name on Card",
    "paymentplaceholder": "Jane Doe",
    "pdf": "PDF",
    "phone": "Phone",
    "phoneNumber": "Phone Number",
    "photos": "Photos",
    "plateNumber": "Plate Number",
    "pleaseSelect": "Please Select",
    "policiesAndProcedures": "Policies and Procedures",
    "policy": "Policy",
    "popupMessage": "You will not be able to recover this user!",
    "popupMessageAdmin": "You are deactivating this Admin User!",
    "popupMessageReseller": "You are deactivating this Reseller!",
    "positiveNumberMessage": "Must be greater than zero",
    "previous": "Previous",
    "privacyPolicy": "Privacy Policy",
    "proceedToAdd": "Proceed To Add",
    "proceedToImport": "Proceed To Import",
    "producerCode": "Reseller Code",
    "qrCode": "Enter Code",
    "radiusSection": "Radius Settings",
    "radiusTolerance": "Radius Tolerance",
    "recoverConfirm": " You will not be able to recover this vehicle!",
    "refresh": "Refresh",
    "regeneratePdf": "Regenerate PDF",
    "region": "Region",
    "removeMFA": "Remove MFA",
    "reported": "Reported",
    "Reseller": "Reseller",
    "resellerCreate": "Reseller created successfully",
    "resellerUpdate": "Reseller updated successfully",
    "reset": "Reset",
    "role": "Role",
    "save": "Save",
    "saveChanges": "Save Changes",
    "saveRegion": "Region added successfully",
    "search": "Search",
    "searchBox": "Search...",
    "searchReseller": "Search...",
    "searchSubReseller": "Search...",
    "select": "Select",
    "send": "Send",
    "serviceCenter": "Service Center",
    "serviceManager": "Service Manager",
    "setUpMFA": "Set Up MFA",
    "shipDocs": "Ship Docs",
    "show": "Show",
    "SHOW": "Show",
    "startTime": "Start Time",
    "state": "State",
    "status": "Status",
    "subject": "Subject",
    "submit": "Submit",
    "subResellerCreate": "Sub Reseller created successfully",
    "subResellerUpdate": "Sub Reseller updated successfully",
    "successfull": "Successfull",
    "summary": "Summary",
    "superAdmin": "Super Admin",
    "sureConfirm": "Are you sure?",
    "sureDeleteRequest": "Are you sure you want to delete this request?",
    "syncData": "Sync Data",
    "tableEmptyMessage": "No data available in table",
    "template": "Template",
    "terminal": "Terminal",
    "terminalAdd": "Terminal added successfully",
    "terminalAddress": "Terminal Address",
    "terminalUpdate": "Terminal updated successfully",
    "termsValidation": "Please Accept Terms and Conditions To Continue",
    "testCompany": "Test Company",
    "timeZone": "Your timezone cannot be obtained from the address entered. Please select your timezone below:",
    "timeZoneOffsetFromUTC": "Time Zone Offset From UTC",
    "timzone": "TimeZone",
    "toLocation": "To",
    "tools": "Tools",
    "total": "Total",
    "totalDistance": "Total Distance",
    "totalHoursWorked": "Total Hours Worked",
    "trailer": "Trailer",
    "trailerInformation": "Trailer Information",
    "trailerList": "List of Trailers",
    "trailerName": "Trailers",
    "truckId": "Truck ID",
    "type": "Type",
    "unAuthorized": "Un authorized",
    "underWriter": "Underwriter",
    "unhandled": "Unhandled",
    "update": "Update",
    "updateAdmin": "Admin Successfully updated",
    "updatedTime": "Updated Time",
    "updateRegion": "Region updated successfully",
    "updateResellerUser": "Reseller User Successfully updated",
    "upgrade": "Upgrade",
    "upload": "Upload",
    "usdotDetails": "USDOT Number deleted successfully",
    "user": "User",
    "userCredentials": "User Credentials",
    "userInformation": "User Information",
    "userMainInformation": "User Main Information",
    "userName": "User Name",
    "validLicenseNumber": "License Number should contain alpha numeric characters only.",
    "validName": "Please enter no more than 10 characters",
    "validNumberMessage": "Please enter a valid number",
    "validNumFormat": "Please fill in the correct format(844-636-1360).",
    "vehicle": "Vehicle",
    "vehicleId": "Vehicle ID",
    "vehicleInformation": "Vehicle Information",
    "vehicleList": "List of Vehicles",
    "vehicleName": "Vehicle Name",
    "vehicles": "Vehicles",
    "version": "Version",
    "view": "View",
    "viewLess": "View Less",
    "viewMore": "View more",
    "webfleetProvider": "Webfleet Provider",
    "WFConnect": "WF.connect Account Information",
    "yes": "Yes",
    "zipCode": "Zip Code",
    "noteDesc": "Notes Description",
    "updatedBy": "Updated By",
    "updatedOn": "Updated On",
    "saveNote": "Save Notes",
    "searchText": "Search...",
    "companyTierChange": "Do you want to assign reseller default tier ({{defaultTier}}) to current company subscription Tier ({{currentTier}})?",
    "companyTierRemoveText": "Do you want to change reseller default tier ({{defaultTier}})?",
    "companyTierChangeText": "Do you want to assign reseller default tier to current company subscription Tier?",
    "resellerAddTierChange": "Do you want to assign parent reseller default tier ({{defaultTier}}) to current reseller ({{currentTier}})?",
    "resellerAddTierChangeText": "Do you want to assign parent reseller default tier to current reseller?",
    "resellerEditTierChange": "Do you want to change current reseller tier ({{currentTier}}) with parent reseller tier ({{defaultTier}})?",
    "resellerEditTierChangeText": "Do you want to change current reseller tier with parent reseller tier?",
    "getaQuotes": "Get a Quote",
    "customStateErrorMessage": "Invalid Jurisdiction. please select Jurisdiction",
    "configuration": "Configuration",
    "emailAlerts": "Email Alerts",
    "alertToEmailInfo": "If no events are selected, it will be considered that all events should be sent.",
    "validName10000": "Maximum allowed count is 10000",
    "lastUpdated": "Last Updated",
    "viewAll": "View All",
    "followVehicle": "Follow Vehicle",
    "deleteMessage": "You can't able to restore the state!",
    "cameraTypeChangeWarning": "You are changing camera type to {{camerType}}. This will reset the Camera serial number and password",
    "quoteId": "DOT No.",
    "cardDetailsSavedSuccesfully": "Card Details Saved Successfully",
    "max20Char": "Maxmium character limit exceeds.",
    "max60Char": "Maxmium 60 character allowed",
    "onlyletterNumber": "Only letters and numbers are allowed",
    "noofIntialTrucks": "Number of initial trucks",
    "noofIntialCamera": "Number Of Initial Cameras",
    "initialCamera": "Initial Camera Count"
  },
  "avatarMenu": {
    "switchToOld": "Switch to Old View",
    "switchToNew": "Switch to New View",
    "messaging": "Messaging",
    "logout": "Logout"
  },
  "bulkDelete": {
    "alertSuccess": "Data has been imported successfully.",
    "deleteError": "An error occurred while deleting",
    "imported": "Data has been imported successfully.",
    "deleteVehicle": "Following {{count}} vehicles are flagged for deletion. Do you want to continue?",
    "allSuccess": "Success",
    "deleted": ": The following {{count}} vehicles have been deleted."
  },
  "leftMenu": {
    "feedback": "Feedback",
    "developerRequests": "Developer Requests",
    "downloadCenter": "Download Center",
    "reports": "Reports",
    "IFTAReport": "IFTA Report",
    "fuelReport": "Fuel Consumption Report",
    "dailyDocuments": "Daily Documents",
    "documents": "Documents",
    "policiesProcedures": "Policies and Procedures",
    "DOTAudit": "DOT Audit",
    "Audit": "Audit",
    "USDOT": "USDOT No. Management",
    "companyData": "Company Data",
    "filters": "Filters",
    "inspections": "Inspections",
    "repairMaintenance": "Repair and Maintenance",
    "accidents": "Accidents",
    "vehicles": "Vehicles",
    "users": "Users",
    "logs": "Logs",
    "csaViolation": "CSA Violations",
    "department": "Departments",
    "camera": "Camera",
    "companies": "Companies",
    "freight": "Freight",
    "dashboard": "Dashboard",
    "scoreCard": "Scorecard",
    "accountReport": "Accounts Report",
    "alerts": "Camera Alerts",
    "cameraAlerts": "Camera Alerts",
    "churnReport": "Churn Report",
    "dailyLogs": "Manage Daily Logs",
    "dataUsage": "Data Usage",
    "debugLogs": "Debug Logs",
    "fmcsaTitle": "FMCSA Responses",
    "fmcsaTitleList": "FMCSA Listing",
    "resellers": "Resellers",
    "revenueReport": "Revenue Report",
    "serviceRequest": "Service Request",
    "serviceRequests": "Service Requests",
    "subResellers": "Sub Resellers",
    "subscription": "Subscription",
    "trailerList": "List of Trailers",
    "trailers": "Trailers",
    "userReport": "User Reports",
    "vehicleList": "List of Vehicles",
    "wlBilling": "WL Billing",
    "wlBillingInfo": "WL Billing Info"
  },
  "dashboard": {
    "udNotification": "You have unassigned Unidentified Driving Time. Please go to the logs tab and assign these logs to the right driver.",
    "driverStatus": {
      "DRIVING": "MANAGE USERS - DRIVING",
      "ON_DUTY": "MANAGE USERS - ON DUTY",
      "SLEEPER_BERTH": "MANAGE USERS - SLEEPER",
      "OFF_DUTY": "MANAGE USERS - OFF DUTY"
    },
    "notInUseVehicles": {
      "pageHeading": {
        "INSHOP": "MANAGE VEHICLES - IN SHOP",
        "OUTOFSERVICE": "MANAGE VEHICLES - OUT OF SERVICE"
      },
      "listHeading": {
        "INSHOP": "List Of Vehicles In Shop",
        "OUTOFSERVICE": "List Of Vehicles Out Of Service"
      }
    },
    "tabs": {
      driverBehavior: window?.$environment?.SERVICE_PROVIDER === 'riskTheory' ? 'Account Behavior' : 'Driver Behavior',
      "vehicleStatus": "Vehicle Status",
      "dailyLogs": {
        "heading": "Daily Logs"
      },
      "driverStatus": {
        "heading": "Drivers Status",
        "lastKnownLocation": "Last Known Location",
        "unit": "Unit",
        "driveTimeRemaining": "Drive Time Remaining",
        "timeUntilBreak": "Time Until Break",
        "onDutyTimeRemaining": "On Duty Time Remaining",
        "dutyCycleRemaining": "Duty Cycle Remaining",
        "currentStatus": "Current Status",
        "engineSpeed": "Engine Speed",
        "lastUpdated": "Last Updated",
        "driveTime": "Drive Time",
        "onDutyTime": "On Duty Time",
        "eld": "ELD"
      },
      "alerts": {
        "enableNotification": "Enable Notification",
        "heading": "Alerts"
      },
      "potentialViolations": {
        "heading": "Potential Violations",
        "pageHeading": "Notifications",
        "violationType": "Violation Type"
      },
      "radiusComplianceAlerts": {
        "company": "Policy Holder Name",
        "radius": "Radius",
        "type": "Type",
        "radiusExperience": "Radius Experience",
        "description": "Description",
        "date": "Date",
        "overage": "Overage",
        "monthInViolation": "Month in Violation",
        "lossControl": "Loss Control",
        "underwriter": "Underwriter"
      },
      "radius": "Radius",
      "severity": "Severity",
      "csaSnapshot": "CSA Snapshot",
      "recentAccidents": "Recent Accidents",
      "developerRequests": "Developer Permission Requests",
      "overview": "Overview"
    },
    "header": {
      "TOTALDRIVERS": "Total Active Drivers",
      "ONDUTY": "On Duty",
      "DRIVING": "Driving",
      "SLEEPER": "Sleeper",
      "OFFDUTY": "Off Duty",
      "TOTALTRUCKS": "Total Trucks",
      "AVAILABLETRUCKS": "Available Trucks",
      "INSHOP": "In Shop",
      "OUTOFSERVICE": "Out of Service",
      "text": "Company Summary"
    }
  },
  "api": {
    "errors": {
      "noService": "Service Temporarily Unavailable",
      "networkError": "Internal server error"
    }
  },
  "resellers": {
    "addHeading": "Add Reseller",
    "editHeading": "Reseller details",
    "listHeading": "Manage Resellers",
    "listSubResellerHeading": "Manage Sub Resellers",
    "code": "Code",
    "joinedDate": "Joined Date",
    "trucksCount": "No. of Trucks",
    "path": "path"
  },
  "users": {
    "addDriver": "Add Driver",
    "addHeading": "Add User",
    "addNewDriver": "Add New Driver",
    "addNewUser": "Add New User",
    "admins": "Admins",
    "adminUsers": "Admin Users",
    "aGExemption": "AG Exemption",
    "All": "All",
    "bigDayShortHaul": "Big Day Short Haul",
    "claimManagers": "Claim Adjusters",
    "drivers": "Drivers",
    "driverStatusHistory": "Driver Status History",
    "DVIROnly": "DVIR Only",
    "editHeading": "User details",
    "enableNonDOTTrip": "Enable Non-DOT Trip",
    "enablePersonalConveyance": "Enable Personal Conveyance",
    "enableYardMoves": "Enable Yard Moves",
    "exemptFromUsingELD": "Exempt from using ELD",
    "expirationDate": "Expiration Date",
    "fleetManager": "Fleet Manager",
    "fleetUsers": "Fleet Users",
    "joined": "Joined",
    "listHeading": "Manage Users",
    "lossControllers": "Loss Controls",
    "mechanicListHeading": "Manage Mechanics",
    "mechanics": "Mechanics",
    "profileHeading": "Edit Profile",
    "quickFilter": "Quick filters:",
    "resellerUsers": "Reseller Users",
    "resetPasswordHeading": "Reset Password",
    "searchMechanic": "Search Mechanic",
    "selectFileToUpload": "Select File to upload",
    "serviceManagers": "Service Managers",
    "underWriters": "Underwriters",
    "userInfo": "User Info",
    "vehicleForDriver": "Vehicle for driver",
    "vehicleForMechanic": "Vehicle for mechanic"
  },
  "logs": {
    "addHeader": "User Information",
    "addLogHeader": "Add logs",
    "addNewRow": "Add new row",
    "allDutyTimeTracker": "Informe de seguimiento de todo el tiempo de servicio,",
    "archiveLogsHeader": "Archive Logs",
    "assignedDriver": "Assigned Driver",
    "backToDashboard": "GO BACK",
    "codriver": "Co-Driver Name",
    "dailyLogExportMessage": "Export dailylog signed status",
    "dateInUtc": "Date (in UTC)",
    "editHeading": "Edit Daily Log",
    "history": "Daily Log History",
    "location": "Location",
    "logBook": "LogBook",
    "logLocation": "Log Signing Location",
    "logs": "Logs",
    "manageLogsHeader": "Manage Logs",
    "manageLogsHeaderSigned": "Signed Logs",
    "manageLogsHeaderUnSigned": "Real-time/Unsigned Logs",
    "noDataMessage": "Invalid request. Click here to go back to dashboard",
    "notes": "Notes",
    "noViolation": "No violation data for the day",
    "oildFieldWaiting": "Oil Field Waiting",
    "spireonTitle": "Daily Logs",
    "stateModifier": "State Modifier",
    "status": "Status",
    "Submit": "Save",
    "timeFrom": "Time From",
    "timeTo": "Time To",
    "unassignedDriveTime": "Unassigned Drive Time",
    "undefinedDriverHeader": "Unidentified driver logs",
    "unidentifiedDriverProfile": "Unidentified Driver Profile",
    "UpdateEvents": "Update events",
    "UpdateGraph": "Update Graph",
    "viewDocument": "View Documents",
    "violations": "Violations"
  },
  "dca": {
    "dcAlert": "DIAGNOSTIC CODE ALERTS",
    "dateFrom": "Date From",
    "dateTo": "Date To",
    "code": "Code",
    "description": "Description",
    "startTime": "Start Time",
    "endTime": "End Time",
    "search": "Search Code"
  },
  "vehicles": {
    "activateIt": "Yes, activate it!",
    "addHeading": "Add Vehicle",
    "assignedVehicles": "Assigned Vehicles",
    "cameraType": "Camera Type",
    "cameraSerialNo": "Camera serail number",
    "cameraPassword": "Camera password",
    "deactivateResellerUser": "Yes, deactivate!",
    "deactivateUser": "Yes, deactivate user!",
    "deleteReseller": "Yes, Delete!",
    "deleteUser": "Yes, Delete!",
    "drivers": "Drivers",
    "editHeading": "Edit Vehicle",
    "email": "E-mail",
    "empId": "Emp Id",
    "exportUser": "Export Users",
    "fuelType": "Fuel Type",
    "fullName": "Full Name",
    "importUserTemplate": "Import User Template",
    "lastLogin": "Last Login",
    "listHeading": "Manage Vehicles",
    "manufact": "Manufact",
    "manufacturer": "Manufacturer",
    "model": "Model",
    "role": "Role",
    "searchUser": "Search User",
    "searchVehicle": "Search Vehicle",
    "searchVehicleTrailer": "Search Vehicle / Trailer",
    "type": "Type",
    "unitId": "Unit ID",
    "users": "Users",
    "vehicleType": "Vehicle Type",
    "vin": "VIN",
    "wlId": "CRM ID",
    "year": "Year",
    "nextMaintenanceDate": "Next Maintenance Date",
    "nextMaintenanceMileage": "Next maintenance Mileage",
    "camera": "Camera",
    "currentOdometer": "Current Odometer",
    "notes": "Notes",
    "deviceType": "Device type",
    "hardwareDevice": "Hardware Device",
    "deviceSn": "Device Serial No:",
    "trailerName": "Trailer",
    "plateNumber": "Plate Number",
    "make": "Make",
    "gvw": "GVW",
    "tabs": {
      "listVehicles": "List of Vehicles",
      "listTrailers": "List of Trailers",
      "roadInspection": "Roadside Inspections"
    },
    "addTrailer": "Add New Trailer",
    "addVehicle": "Add New Vehicle",
    "cameraId": "Camera ID",
    "cameraStatus": "Status",
    "dateTimeFrom": "Date/Time From",
    "dateTimeTo": "Date/Time To",
    "exportTrailer": "Export Trailers",
    "exportVehicle": "Export Vehicles",
    "importTra": "Import Trailers",
    "importTrailerTemplate": "Import Trailers Template",
    "importVeh": "Import Vehicles",
    "importVehicleTemplate": "Import Vehicles Template",
    "inspectionForm": "Inspection Form",
    "mechanics": "Mechanic",
    "seatBeltStatus": "Seat Belt Status",
    "trackVehicle": "Track Vehicle",
    "trailerType": "Trailer Type"
  },
  "chat": {
    "sendMessage": "Send message",
    "selectDriver": "To: Search...",
    "newConvo": "New Conversation",
    "broad": "Broadcast",
    "search": "Search...",
    "type": "Type"
  },
  "trailers": {
    "deleteIt": "Yes, delete it!",
    "recoverConfirm": " You will not be able to recover this trailer!",
    "trailerType": "Trailer Type",
    "addHeading": "Add Trailer",
    "editHeading": "Edit Trailer"
  },
  "roadInspection": {
    "driverId": "Driver ID",
    "defectFound": "Defect Found"
  },
  "reports": {
    "downloadReports": "Download Reports"
  },
  "accidents": {
    "heading": "MANAGE ACCIDENTS",
    "witnessStatement": "Witness Statement",
    "accidentReport": "Accident Report",
    "dateAndTime": "Date and Time",
    "viewWitness": "View Witnesses",
    "viewReport": "View Report",
    "viewReceipt": "View Receipt"
  },
  "eld": {
    "all": "All",
    "delivery_receipts": "Delivery Receipt",
    "dispatch_records": "Dispatch Record",
    "bills_of_landing": "Bill of Lading",
    "receipts": "Receipt",
    "weigh_tickets": "Weigh Ticket",
    "communication_records": "Communication record",
    "other_documents": "Other Document"
  },
  "documents": {
    "listHeading": "Documents"
  },
  "developerRequests": {
    "listHeading": "Developer Permission Requests",
    "developerName": "Developer Name"
  },
  "departments": {
    "terminalsAndDepartments": "Terminals and Departments",
    "noLocations": "No location added",
    "noDepartments": "No departments under this terminal",
    "addTerminal": "Add Terminal",
    "editTerminal": "Edit Terminal",
    "addRegion": "Add Region",
    "editRegion": "Edit Region",
    "regionName": "Region Name",
    "fleetManagers": "Fleet Managers",
    "dot": "Dot #",
    "addDepartment": "Add Department",
    "editDepartment": "Edit Department",
    "addLocation": "Add Location",
    "editLocation": "Edit Location",
    "deleteTerminal": "Delete Terminal",
    "deleteDepartment": "Delete Department",
    "serviceCenters": "Service Centers",
    "filter": "Filters",
    "addFilter": "Set Filter"
  },
  "registration": {
    "addDepartment": "Add Department",
    "addFilter": "Set Filter",
    "addLocation": "Add Location",
    "addRegion": "Add Region",
    "addTerminal": "Add Terminal",
    "deleteDepartment": "Delete Department",
    "deleteTerminal": "Delete Terminal",
    "dot": "Dot #",
    "editDepartment": "Edit Department",
    "editLocation": "Edit Location",
    "editRegion": "Edit Region",
    "editTerminal": "Edit Terminal",
    "filter": "Filters",
    "fleetManagers": "Fleet Managers",
    "noDepartments": "No departments under this terminal",
    "noLocations": "No location added",
    "regionName": "Region Name",
    "serviceCenters": "Service Centers",
    "terminalsAndDepartments": "Terminals and Departments",
    "companyInfoHeading": "COMPANY INFORMATION",
    "userInfoHeading": "FLEET MANAGER INFORMATION",
    "initialTrucks": "Number of Trucks",
    "maintenancePeriod": "Maintenance Period (Months)",
    "maintenanceMileage": "Maintenance Mileage",
    "subscriptionTier": "Subscription Tier",
    "contractLength": "Contract Length (Years)",
    "createAccount": "Create Account",
    "producerCode": "Producer Code",
    "iAgree": "I agree to the",
    "termsOfUse": "Terms of Use",
    "accept": "Accept",
    "totalAmount": "Total amount: $",
    "paymentConfirmation": "PAYMENT CONFIRMATION",
    "noOfTrucks": "Number of Trucks",
    "costperTruck": "Cost per truck ($)",
    "salesTax": "Sales Tax ($)",
    "discount": "Discount (%) (if any)",
    "total": "Total Amount ($)",
    "confirm": "Confirm",
    "iAcceptAll": "I accept the following terms and conditions."
  },
  "csaViolation": {
    "listHeading": "CSA VIOLATIONS",
    "dvirLink": "DVIR Link",
    "dvirStatus": "DVIR Status",
    "roadsideDot": "Roadside DOT Inspection",
    "workOrder": "Work Order",
    "workOrderStatus": "Work Order Status",
    "oos": "OOS",
    "severity": "Severity"
  },
  "iftaMileage": {
    "listHeading": "IFTA Mileage",
    "search": "Search",
    "notLessThanZero": "Meter reading should not be less than zero",
    "addressError": "Invalid address.Can't able to find address.",
    "endMeterError": "end meter should be greater than start meter",
    "tooltip": "Download Truck GPS history",
    "hideLabel": "Hide States with no mileage",
    "activeVehicles": "Active Vehicles",
    "deactivateVehicles": "Deactivated Vehicles",
    "odometer": "Calculate From Odometer",
    "updateMiles": "Update Miles",
    "totalMiles": "Total Miles",
    "totalTaxableMiles": "Total Taxable Miles",
    "truck": "Truck",
    "Jurisdiction": "Jurisdiction",
    "generateReport": "Generate Report",
    "fuelUsage": "Fuel Purchased",
    "newState": "New Jurisdiction",
    "vehicle": "Search By Vehicle",
    "stateSearch": "Search By Jurisdiction",
    "gpsBegins": "Beginning GPS Lat & Long",
    "gpsEnds": "Ending GPS Lat & Long",
    "startMeter": "Start Odometer",
    "endMeter": "End Odometer",
    "addState": "Add Jurisdiction",
    "editState": "Edit Jurisdiction",
    "startCity": "Start City",
    "endCity": "End City",
    "taxable": "Taxable"
  },
  "fuelConsumption": {
    "pageHeading": "FUEL CONSUMPTION REPORT",
    "search": "Search Report by Vehicle",
    "currentDrivers": "Current Drivers",
    "location": "Latest Fueling Location",
    "Jurisdiction": "Jurisdiction",
    "JurisdictionLocation": "Jurisdiction/Location",
    "miles": "Miles per Gallon",
    "history": "Refills History",
    "unknown": "Unknown"
  },
  "refillsHistory": {
    "pageHeading": "History of Refills",
    "odometer": "Odometer",
    "gallons": "Gallons",
    "fuelAmount": "Fuel Amount (Gallons)",
    "Jurisdiction": "Jurisdiction",
    "cost": "Total Cost"
  },
  "usDotManagement": {
    "pageHeading": "USDOT NUMBER MANAGEMENT PAGE",
    "search": "Search USDOT No",
    "usDotNo": "USDot No.",
    "carrierName": "Name of Carrier",
    "mainAddress": "Main Office Address",
    "zip": "Zip",
    "addDot": "Add New DOT",
    "editDot": "Edit DOT",
    "message": "Message",
    "send": "Send"
  },
  "inspections": {
    "advancedDvir": "Advanced DVIR",
    "advancedInput": "Section",
    "assetsCount": "Assets Count",
    "assetsName": "Asset Name",
    "assetsType": "Assets Type",
    "bulkDownloadReport": "Bulk Download Report",
    "customDvir": "Custom DVIR",
    "dvirError": "Configuration type or section name not entered",
    "hasDefects": "Has Defects?",
    "inspectionReport": "Inspection Report",
    "inspectionType": "Inspection Type",
    "inspectionStatus": "Inspection Status",
    "listHeading": "Manage Inspections",
    "listHeading1": "Inspections",
    "searchBycompany": "Search By Company",
    "searchByMechanic": "Search By Mechanic",
    "unitType": "Unit Type",
    "user": "Search By User",
    "vehicle": "Search By Vehicle",
    "viewReport": "View Report"
  },
  "workOrders": {
    "addHeading": "WORK ORDER DETAILS",
    "addWorkOrders": "Add WorkOrder",
    "assignToServiceCeenter": "Assign to another Service Center",
    "assignWorkOrder": "Assign Service Request",
    "cause": "Cause",
    "closed": "Closed WorkOrders",
    "company": "Company",
    "concern": "Concern",
    "correction": "Correction",
    "defectDetails": "Defect Details",
    "driver": "Driver",
    "dueDate": "Due Date",
    "dvirLocation": "DVIR Location",
    "engineOil": "Engine Oil Quantity",
    "fuel": "Fuel Quantity",
    "hydraulicOil": "Hydraulic Oil Quantity",
    "inspectionDetails": "INSPECTION DETAILS",
    "inspectionReport": "Inspection Reports",
    "laborCost": "Labor Cost ($)",
    "manageMechanics": "Manage Mechanics",
    "manageParts": "Manage Parts",
    "mechanic": "Mechanic",
    "noReport": "No Report",
    "notes": "Notes",
    "open": "Open WorkOrders",
    "pageHeading": "MANAGE WORK ORDERS",
    "parts": "Parts",
    "partsCost": "Parts Cost ($)",
    "receipts": "RECEIPTS",
    "repairCost": "Repair Cost($)",
    "reportedDate": "Reported Date",
    "scheduled": "Scheduled",
    "scheduledDate": "Scheduled Date",
    "search": "Search Work Order",
    "serviceCenter": "Service Center",
    "serviceRequestEditSuccess": "Service Repair Request Has Been Updated.",
    "serviceType": "Service Type",
    "status": "Status",
    "totalCost": "Total Cost ($)",
    "unableToChangeStatus": "Service Request assigned to a service center. Unable to make this change!",
    "unavailable": "-",
    "unitType": "Unit Type",
    "vehicle": "Vehicle",
    "viewInspectionreport": "View Inspection Report",
    "viewPhotos": "View Photos",
    "viewPicture": "View Picture",
    "viewReceipt": "View Receipt",
    "viewReport": "View Report",
    "windShieldFluid": "Windshield washer Quantity",
    "workOrderEditSuccess": "Work Order Has Been Updated.",
    "workOrderNo": "Work Order #"
  },
  "parts": {
    "pageHeading": "Manage Parts",
    "partName": "Part",
    "partsInventory": "# in Inventory",
    "cost": "Parts Cost ($)",
    "addPart": "Add Part",
    "partTitle": "Parts",
    "costError": "Please enter a value greater than or equal to 0."
  },
  "companyData": {
    "addPageHeading": "Add Company",
    "advanceSettings": "Advance Settings",
    "assetsType": "Assets Type",
    "cancelSubscription": "Cancel Subscription",
    "companyName": "Company Name",
    "contactPerson": "Contact Person",
    "contractExpirationDate": "Contract Expiration Date",
    "currentSubscriptionCost": "Current Subscription Cost",
    "defaultCycleRule": "Default Cycle Rule",
    "DVIR": "DVIR",
    "editPageHeading": "Edit Company",
    "enablecompanyCheckbox": "Enable Oil Field Waiting",
    "exceptions": "Exceptions",
    "expiryDate": "Insurance Expiration Date",
    "fleetManagerInformation": "Fleet Manager Information",
    "garagingAddress": "Garaging Address:",
    "homeTimeZone": "Home Time Zone",
    "Ifta": "IFTA",
    "insuranceSettings": "Insurance Settings",
    "invalidGaragingAddress": "Unable to generate coordinates from the garaging address provided. Please provide more specific address",
    "lossControl": "Loss Control",
    "maintainanceMileage": "Maintenance Mileage",
    "maintainancePeriod": "Maintenance Period",
    "maintainancePeriodMonth": "Maintenance Period (Months)",
    "noOfTrucks": "Number Of Trucks",
    "otherLocationAddress": "Other Location Address",
    "otherLocationContactPerson": "Other Location Contact Person",
    "otherLocationPhoneNumber": "Other Location Phone Number",
    "pageHeading": IS_ADMIN ? "Company Information" : "Company Data",
    "paymentInformation": "Payment Information",
    "radiusCompliance": "Radius Compliance",
    "skipcompanyCheckbox": "Skip Vehicle Filter Search",
    "underwriter": "Underwriter",
    "updateCardDetails": "Update Card Details",
    "updateCreditCardDetails": "Update Credit Card Details",
    "vehicleType": "Vehicle Type",
    "website": "Website",
    "noOfCameras": "Initial Camera Count",
    "billingInformation": "Billing Information",
    "noOfActiveTrucks": "Number of active trucks"
  },
  "paymentInformation": {
    "listHeading": "Billing Details",
    "listHeadingPayment": "Payment Details",
    "paymentId": "Payment Id",
    "contractExpiry": "CONTRACT EXPIRATION DATE",
    "companyInfo": "Company Info",
    "contractHistory": "Contract History",
    "startDate": "Contract Start Date",
    "contractLength": "Contract Length",
    "nextBilling": "Next Billing Date",
    "paymentHistory": "Billing History",
    "createdDate": "Created Date",
    "paidDate": "Paid Date",
    "unitCount": "Unit Count",
    "cost": "Cost Per Unit",
    "receipt": "Payment Receipt",
    "start": "Start Date",
    "end": "End Date",
    "noOfDays": "No.Of Days",
    "status": "Payment Status",
    "company": "Company Name",
    "companyInfoHeading": "Company Info",
    "paymentHistoryHeading": "Payment History",
    "paymentHistoryText": "Payment History"
  },
  "suspended": {
    "listHeading": "Subscription",
    "buttonText": "Pay With Card",
    "title": "Biliing Details",
    "description": "You have active contract from",
    "to": "till",
    "payButtonText": "ADD CARD DETAILS ",
    "expiredContract": "Your contract has expired.",
    "saveButtonText": "Save"
  },
  "policies": {
    "ACCIDENT_INVESTIGATION": "Accident Investigation",
    "ALLOW_USING_PHONES": "Allow Bluetooth Usage",
    "chooseImage": "Please choose .png or .jpg file",
    "companyLogo": "Company Logo",
    "CUSTOM_POLICY": "Custom Policy",
    "customPolicies": "Custom Policies",
    "DISTRACTION_FREE_DRIVING": "Distraction Free Driving",
    "DRESS_CODE": "Dress Code",
    "DRIVER_SELECTION_MVR": "Driver Selection and MVR",
    "DRIVING_TRAINING": "Driving Training",
    "heading": "Policies and Procedures",
    "INSPECTION": "Inspection",
    "LOSS_CONTROL_MANUAL_POLICY": "Loss Control Manual",
    "mainInfo": "Main Information",
    "MIN_DRIVER_AGE": "Minimum driver age allowed",
    "MIN_HOURS": "Hours of Training to be Completed Annually",
    "MIN_YEARS_ON_SIMILAR_EQUIPMENT": "Minimum years on similar equipment",
    "NUMBER_OF_ACCIDENTS_ALLOWED": "Maximum number of accidents",
    "NUMBER_OF_CITATIONS_ALLOWED": "Maximum allowable number of citations",
    "PSP_USAGE": "PSP Usage",
    "SAFETY_PERSON_FULL_NAME": "Full Name of Safety Manager",
    "selectPolicies": "Select Policies",
    "TRAINING_DAYS": "Training Days"
  },
  "potentialViolations": {
    "heading": "Potential Violations",
    "pageHeading": "Manage Violations",
    "violationType": "Violation Type"
  },
  "dailyDocuments": {
    "receipt": "Receipt",
    "users": "Users",
    "documentType": "Document Type",
    "cusName": "Customer Name/Job Name",
    "uploadNewDoc": "Upload New Document"
  },
  "popup": {
    "success": "Success"
  },
  "reportPage": {
    "allDutyTimeTracker": "All Duty time tracker Report",
    "bayIndustriesPayroll": "Payroll Report",
    "billOfLading": "Bill Of landing Report",
    "borderStates": "Document Time Report",
    "DailyFailedInspectionReport": "Failed Inspection Report",
    "DailyHocDriverViolation": "HOS Violations Report",
    "DailyUnidentifiedDrivingReport": "Unidentified driving report",
    "dailyUnsignedLogReport": "Unsigned Log Report",
    "driverPerf": "Driver Performance Report",
    "drivingEvents": "Driving Event Report",
    "dutyStatus": "Duty Status",
    "editedData": "Edited Data Report",
    "eldDisconn": "ELD Disconnect Report",
    "hos": "HOS Violations Details",
    "malFunc": "Malfunction Report",
    "MonthlyHOSDriverViolationsReport": "Monthly HOS Driver Violations Report",
    "MonthlyUnsignedLogReport": "Monthly Unsigned Log report",
    "noOfRequestsPerDay": "No Of Requests Per Day",
    "odoJump": "Odometer Jump Report",
    "pastDueServiceRequests": "Past Due Service Requests",
    "pendingDriverDVIR": "Pending Driver DVIR",
    "pendingMechanic": "Pending Mechanic",
    "rejectedEdits": "Rejected Edits",
    "unassigned": "Unassigned Driving Report",
    "violation": "Violation Report",
    "dtc": "DTC Report"
  },
  "graphTitles": {
    "hardAcceleration": "Hard Acceleration",
    "hardDeceleration": "Hard Deceleration",
    "speeding": "Speeding",
    "hoursExceeding": "Driving Hours Exceeded",
    "fuelEconomy": "Fuel Economy",
    "nonBuckledSeatbelt": "Non Buckled Seat Belt Warning",
    "hardTurn": "Hard Turn"
  },
  "companies": {
    "listHeading": "Manage Companies",
    "company": "Company",
    "dot": "Dot #",
    "activeTrucks": "Active Trucks",
    "payment": "BILLING DETAILS",
    "contractLength": "Contract Length",
    "contractExpiration": "Contract Expiration",
    "registrationDate": "Registration Date",
    "status": "Status",
    "producerCode": "Reseller Code",
    "producerName": "Reseller Name",
    "companyName": "Company Name",
    "email": "Email",
    "phone": "Phone",
    "severity": "Severity",
    "fleetScore": "Fleet Score (out of 100)",
    "fleetManager": "Fleet Manager",
    "searchCompanies": "Search Companies",
    "activeVehicles": "Active Vehicles",
    "lossControl": "Loss Control",
    "xDate": "X-Date",
    "alerts": "Alerts",
    "comapanyNumber": "Company #",
    "policyHolderNumber": "Policy Holder #",
    "paymentStatus": "Payment Status"
  },
  "defectDetails": {
    "area": "Area",
    "part": "Part",
    "defectDetails": "Defect Details",
    "commentsByMechanic": "Comments by Mechanic",
    "fixStatus": "Fix Status",
    "comments": "Comments by Driver",
    "status": "Verification Status",
    "viewPhoto": "View Photo"
  },
  "scoreCard": {
    "heading": ":name Scorecard",
    "fleet": "Fleet",
    "policyHolderManagementScore": "Policy Holder Management Score",
    "policyHolderManagement": "Policy Holder Management",
    "address": "Address",
    "dotNumber": "DOT Number",
    "xDate": "X-Date",
    "date": "Report Date",
    "fleetManagement": "Fleet Management",
    "operatingTerritory": "Operating Territory",
    "fleetManagementScore": "Fleet Management Score",
    "vehicleInspectionScore": "Vehicle Inspection Score",
    "consistentEquipment": "Consistent Equipment",
    "vehicleComposition": "Vehicle Composition",
    "driverTurnOver": "Driver Turn Over",
    "driverTenure": "Driver Tenure (Years)",
    "quickStats": "Quick stats",
    "radiusCompliance": "Radius Compliance",
    "radiusTable": {
      "driverName": "Driver Name",
      "vehicle": "Vehicle",
      "radius": "Radius",
      "radiusExperience": "Radius Experience",
      "overage": "Overage",
      "date": "Date of Violation"
    },
    "radiusStats": "Daily Radius"
  },
  "newScoreCard": {
    "last30Days": "Last 30 days",
    "currentPolicyPeriod": "Current Policy time Period",
    "heading": "Scorecard Overview",
    "selectPeriod": "Select Period",
    "unpoweredDays": "Unpowered Days",
    "poweredDays": "Powered Days",
    "driverBehavior": "Driver Behaviour",
    "fleetScore": "Fleet Score",
    "radiusViolation": "Radius Violation",
    "distractedDriving": "Distracted Driving",
    "speeding": "Speeding",
    "contact": "Contact",
    "totalVehicle": "Total Vehicles",
    "accidentTooltipTitle": "Accident is graded based on the following events :",
    "speedingTooltipTitle": "Speeding is graded based on the following events : ",
    "distractedTooltipTitle": "Distracted Driving is graded based on the following events : "
  },
  "scorecard": {
    "driverBehavior": "Driver Behavior",
    "unpoweredDays": "Unpowered Days",
    "unpoweredDaysDescription": "Based on the number of days trucks were powered. Higher powered days result in a higher score.<br/><br/><i>Method: 0.2 * Powered Days Score</i>",
    "driverBehaviorDescription": "Calculated based on the number of driving events. The score represents safe driving behavior, with fewer events leading to a higher score.<br/><br/><i>Method: 0.6 * Driver Behavior Score</i>",
    "radiusViolations": "Radius Violations",
    "radiusViolationsDesc": "Measures the days trucks violated the predefined radius. Fewer violation days result in a higher score.<br/><br/><i>Method: 0.2 * Radius Violation Score</i>",
    "total": "Total",
    "vehicle": "Vehicles",
    "driverBehaviorDesc": "Calculated based on the number of driving events across all trucks.<br /><br /><i>Method: 100 - (Sum of Events of all trucks / (Total Working Days * Total Trucks)) * 100.</i><br /><br />The pie chart shows the number of trucks grouped by their individual performance percentages, indicating how many trucks fall within each defined range.",
    "actualScore": "Actual Score",
    "distractedDriving": "Distracted Driving",
    "accident": "Accident",
    "speeding": "Speeding",
    "moreInfo": "More Info",
    "unpoweredDaysGraphDesc": "Calculated based on the number of days trucks were powered.<br /><br /><i>Method: Sum of each truck's Powered Days / (Total Working Days * Total Trucks) * 100.</i><br /><br />The pie chart shows the number of trucks grouped by their individual performance percentages, indicating how many trucks fall within each defined range.",
    "unpoweredDaysTotalDesc": "The cumulative number of unpowered days across all trucks in the fleet",
    "radiusViolationGraphDesc": "Calculated based on the number of days trucks violated the predefined radius.<br /><br /><i>Method: 100 - (Sum of each truck's Violation Days / (Total Working Days * Total Trucks)) * 100.</i><br /><br />The pie chart shows the number of trucks grouped by their individual performance percentages, indicating how many trucks fall within each defined range.",
    "radiusViolationTotalDesc": "The cumulative number of radius violation days across all trucks in the fleet",
    "noDataText": "No Data Available !",
    "excellent": "Excellent",
    "good": "Good",
    "average": "Average",
    "belowAverage": "Below Average"
  },
  "banner": {
    "tellUs": "Tell us more about your fleet!",
    "haveCameraQ": "Do you have Cameras?",
    "haveInsuranceQ": "Who is your Insurance Provider?",
    "yes": "Yes",
    "no": "No",
    "cameraProviderQ": "Who is your Camera Provider?",
    "policyRenewQ": "When does your Policy Renew?",
    "submit": "Submit",
    "later": "Cancel",
    "thankYou": "Thank you for your response!",
    "thankYouInfo": "This window will disappear in {{ count }} seconds",
    "close": "OK",
    "email": "Email Address",
    "phone": "Phone Number",
    "emailValidation": "Email must be a valid",
    "cameraProviderPlaceholder": "Enter your camera provider",
    "insuranceProviderPlaceholder": "Enter your Inusurance provider",
    "emailPlaceholder": "example@domain.com",
    "phoneNumberPlaceHolder": "000-000-0000"
  },
  "fmcsa": {
    "title": "FMCSA Listing",
    "Reseller": "Reseller",
    "driver": "Driver",
    "vehicle": "Vehicle",
    "date": "Date",
    "file": "File",
    "submissionId": "Submission Id",
    "response": "Response",
    "message": "Message",
    "showMore": "Show More",
    "userId": "User Id",
    "platform": "Platform"
  }
}